// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__9n-D3","col":"CardReaderDesc_col__1JDqu","label":"CardReaderDesc_label__Yccbl"};